// La segunda pestaña de la barra de abajo, por mundo (I3 del plan de la
// interfaz de los tres mundos, docs/plan-interfaz-tres-mundos.md, decisión
// del fundador 2026-10-04). Dominio puro: App solo traduce la respuesta a
// una pestaña.
//
// El estudiante que todavía no está en internado no tiene turno que
// documentar: su pestaña del medio era "En turno" y le abría una pantalla
// que le dice "esto es para tu internado". Su herramienta de todos los días
// es el PAE, así que esa pestaña pasa a ser PAE. La interna en curso, la
// enfermera y el TENS conservan En turno.
//
// Se llama con el perfil DEL MUNDO (perfilParaMundo): una enfermera de
// visita en MiPAE Estudiante ve PAE. La frontera TENS no depende de esto:
// "En turno" se sigue decidiendo con el perfil real (miTurnoEsCapaTens).
import { veEnTurnoEstudiante } from './perfil';

// Kill-switch ON por defecto. Se lee al llamar (no al cargar el módulo) para
// que los tests lo puedan apagar como los demás interruptores de mundos.
export function navPorMundoHabilitada() {
  return process.env.REACT_APP_NAV_POR_MUNDO_ENABLED !== 'false';
}

/**
 * @param {object|null} perfil  perfil del mundo
 * @returns {'turno'|'pae'}
 */
export function segundaPestana(perfil) {
  if (!navPorMundoHabilitada()) return 'turno';
  // Solo el rol estudiante sin internado en curso cambia. Sin sesión o sin
  // rol la barra queda como siempre: esa decisión no se tomó.
  return veEnTurnoEstudiante(perfil) ? 'pae' : 'turno';
}

// Mientras carga el perfil (hay sesión pero todavía no hay rol) la barra
// mostraba "En turno" y saltaba a "PAE" un instante después (hallazgo de la
// revisión, 2026-10-04). El dispositivo recuerda la última pestaña decidida
// con el perfil REAL (la casa: al abrir la app siempre se vuelve a casa) y la
// usa en ese instante. Solo guarda 'pae' o 'turno'; cualquier fallo de
// almacenamiento cae a 'turno', la barra de siempre.
const CLAVE_SEGUNDA = 'mipae:nav:segunda';

export function recordarSegundaPestana(valor) {
  if (valor !== 'pae' && valor !== 'turno') return;
  try { localStorage.setItem(CLAVE_SEGUNDA, valor); } catch { /* sin almacenamiento */ }
}

export function segundaPestanaRecordada() {
  if (!navPorMundoHabilitada()) return 'turno';
  try { return localStorage.getItem(CLAVE_SEGUNDA) === 'pae' ? 'pae' : 'turno'; } catch { return 'turno'; }
}
